export default __webpack_public_path__ + "static/media/avatar_6.bfa278a0.png";